<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 财务中心->线下充值申请记录 -->
    <div class="main2">
      <div class="title">线下充值申请记录</div>

      <div class="main2">
        <div class="search">
          <el-form :model="queryParams" ref="queryForm" :inline="true">
            <el-form-item label="申请时间段" prop="beginTime">
              <el-date-picker
                clearable
                size="small"
                style="width:200px"
                v-model="queryParams.beginTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="开始时间"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="—" prop="endTime" class="df-sjkjs">
              <el-date-picker
                clearable
                size="small"
                style="width:200px;"
                v-model="queryParams.endTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="截止时间"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-button
                icon="el-icon-search"
                size="small"
                style="border-color:#97c5e9;font-size:14px;border-radius:0;padding:7px 20px 8px;"
                @click="search"
                >搜索</el-button
              >
            </el-form-item>
          </el-form>
        </div>

        <el-table
          :data="aryList"
          style="width: 100%"
          :cell-style="{
            'text-align': 'center',
            'border-color': '#dbdbdb',
            position: 'relative',
            'background-color': '#f3f1f2',
            'border-right': '1px solid #e7e6e4',
          }"
          :header-cell-style="{
            'background-color': '#b6b6b6',
            color: '#000',
            fontSize: '14px',
            fontWeight: '300',
            'text-align': 'center',
          }"
        >
          <el-table-column prop="num" align="center" label="序号" width="65">
            <template slot-scope="scope">
              {{ (pageNum - 1) * 10 + (scope.$index + 1) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="rechargeBeforeBalance"
            min-width="100"
            label="充值金额"
            align="right"
          >
            <template slot-scope="scope">
              {{ to_f(scope.row.payMoney || "0.00") }}
            </template>
          </el-table-column>

          <el-table-column
            prop="accountNumberName"
            label="收款账号"
            min-width="120"
          >
            <template slot-scope="scope">
              {{ scope.row.accountNumberName }}
            </template>
          </el-table-column>

          <el-table-column prop="createTime" label="变更时间" min-width="180">
            <template slot-scope="scope">
              {{ parseTime(scope.row.createTime || "2021-01-01 12:00:00") }}
            </template>
          </el-table-column>

          <el-table-column prop="remark" label="备注">
            <template slot-scope="scope">
              {{ scope.row.remark || "" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="accountNumberName"
            label="处理状态"
            min-width="80"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">已处理</span>
              <span v-else-if="scope.row.status == 1">未处理</span>
              <span v-else> 暂无状态</span>
            </template>
          </el-table-column>

          <el-table-column prop="处理结果" label="详情" min-width="200">
            <template slot-scope="scope">
              {{ scope.row.tranResult || "暂无详情" }}
            </template>
          </el-table-column>
        </el-table>
        <br /><br />
        <el-pagination
          v-if="totalPages > 1"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
        <el-button size="mini" style="display:inline-block;">GO</el-button>
      </div>
    </div>
    <!-- 财务中心->线下充值申请记录 -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import { getOfflinePayListRequest } from "../../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      totalPages: 1, //总页码,
      pageNum: 1, //当前页码
      total: 1, //总条数
      pageSize: 10, //每页条数
      aryList: [], // 数据列表
      token: "", //token
      queryParams: {
        orderNum: null,
        beginTime: null,
        endTime: null,
      },
    };
  },

  components: {},

  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getList();
    },

    getList() {
      // 3.4.getList
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        params: {
          beginTime: this.queryParams.beginTime,
          endTime: this.queryParams.endTime,
        },
      };

      getOfflinePayListRequest(data).then((res) => {
        if (res) {
          this.total = res.totals || 1;
          this.totalPages = this.getTotalPages(this.total, this.pageSize);
          this.aryList = res.data;
        }
      });
    },
    search() {
      this.pageNum = 1;
      this.getList();
    },
  },

  mounted() {
    // 3.4.mounted
    if (localStorage.token) {
      this.token = localStorage.token;
      this.getList();
    }
  },
};
</script>
